// 配电箱贴图
import { formatterNumber } from '@/utils/utils'
const boxTexture = new THREE.TextureLoader().load('/static/img/tietu.jpg')
boxTexture.wrapS = THREE.RepeatWrapping
boxTexture.wrapT = THREE.RepeatWrapping
boxTexture.repeat.x = 20

const tubeRadius = 5
const currentRadius = 3

export default class Box {
  scale = 0.15
  infoPlaneWidth = 1024
  infoPlaneHeight = 512
  boxMesh = null // 整个配电箱
  boxNameMesh = null // 塔机名字
  boxGroup = new THREE.Group() // 整个配电箱
  currentGroup = new THREE.Group() // 电流
  infoPlaneGroup = new THREE.Group() // 信息板
  currentTexture = new THREE.TextureLoader().load('/static/img/run.png')
  onlineMaterial = new THREE.MeshPhongMaterial({color: 0xcc6635, map: boxTexture})
  offlineMaterial = new THREE.MeshLambertMaterial({color: 0x5f5f5f})
  loader = new THREE.STLLoader()
  infoPlaneMaterial = null
  oldRunData = {} // 存储上一次的数据

  constructor () {
    this.firstBox = {x: 1300 * this.scale, y: 2098 * this.scale, z: 535 * this.scale}
    this.secondBox = {x: 1300 * this.scale, y: 1663 * this.scale, z: 455 * this.scale}
    this.thirdBox = {x: 600 * this.scale, y: 1469 * this.scale, z: 455 * this.scale}
  }

  // 初始化塔机
  async initBox (config, scene, callback) {
    const {hashId, x, z, level, name, parentBox} = config
    this.hashId = hashId
    this.name = name
    this.x = x
    this.z = z
    this.scene = scene
    this.level = level
    this.parentBox = parentBox
    let stlAddress = '/static/stl/1box.stl'
    this.currentBox = this.firstBox
    switch (level) {
      case 1:
        // 添加一级箱
        stlAddress = '/static/stl/1box.stl'
        this.currentBox = this.firstBox
        break
      case 2:
        // 添加二级箱
        stlAddress = '/static/stl/2box.stl'
        this.currentBox = this.secondBox
        break
      case 3:
        // 添加三级箱
        stlAddress = '/static/stl/3box.stl'
        this.currentBox = this.thirdBox
        break
      default:
        break
    }
    await this.addName().then((mesh) => {
      this.boxNameMesh = mesh
      this.boxGroup.add(this.boxNameMesh)
    })
    // 添加管子
    if (parentBox) {
      await this.addTube(parentBox).then((group) => {
        scene.add(group)
      })
    }
    // 添加电流
    if (parentBox) {
      await this.addCurrent(parentBox).then((group) => {
        this.currentGroup = group
        this.currentGroup.visible = false
        scene.add(this.currentGroup)
      })
    }
    // 添加信息板
    await this.addInfoPlane().then((mesh) => {
      this.infoPlaneGroup.add(mesh)
      this.infoPlaneGroup.visible = false
      this.boxGroup.add(this.infoPlaneGroup)
    })
    await this.initModelCommon(stlAddress).then((mesh) => {
      mesh.geometry.center()
      if (level === 1) {
        mesh.position.y = this.currentBox.y / 2 + 1
      } else {
        mesh.position.y = this.currentBox.y / 2
      }
      this.boxMesh = mesh
      this.boxGroup.add(this.boxMesh)
    })
    this.animate()
    this.oldRunData = {isOnline: false, hasCurrent: false}
    this.boxGroup.position.set(x, 0, z)
    scene.add(this.boxGroup)
    callback()
  }

  // 初始化模块
  initModelCommon (url) {
    const self = this
    return new Promise((resolve) => {
      self.loader.load(url, function (geometry) {
        // geometry.computeBoundingBox()
        // console.log(geometry.boundingBox)
        let mesh = new THREE.Mesh(geometry, self.offlineMaterial)
        mesh.name = self.hashId
        mesh.scale.set(self.scale, self.scale, self.scale)
        resolve(mesh)
      })
    })
  }
  // 添加塔机名字
  addName () {
    return new Promise((resolve) => {
      const size = this.name.length * 45
      let index = 1
      while (Math.pow(2, index) < size) {
        index++
      }
      const newSize = Math.pow(2, index + 1)
      const ctx = document.createElement('canvas').getContext('2d')
      ctx.canvas.width = newSize
      ctx.canvas.height = newSize
      ctx.fillStyle = '#ffffff'
      ctx.font = 'bold 70px arial'
      ctx.textAlign = 'center'
      ctx.fillText(this.name, newSize / 2, newSize / 2)
      const texture = new THREE.CanvasTexture(ctx.canvas)
      texture.needsUpdate = true
      const nameMaterial = new THREE.MeshLambertMaterial({
        map: texture,
        transparent: true
      })
      let geometryPlane = new THREE.PlaneGeometry(newSize / 2, newSize / 2)
      const mesh = new THREE.Mesh(geometryPlane, nameMaterial)
      mesh.position.y = this.currentBox.y + 20
      mesh.position.z = this.currentBox.z / 2 - 3
      resolve(mesh)
    })
  }
  // 添加信息板
  addInfoPlane () {
    return new Promise((resolve) => {
      const boxX = this.currentBox.x / 2
      const boxY = this.currentBox.y
      this.showText().then((canvas) => {
        const texture = new THREE.CanvasTexture(canvas)
        texture.needsUpdate = true
        this.infoPlaneMaterial = new THREE.MeshLambertMaterial({
          map: texture,
          side: THREE.DoubleSide,
          transparent: true
        })
        let geometryPlane = new THREE.PlaneGeometry(768, 384)
        const mesh = new THREE.Mesh(geometryPlane, this.infoPlaneMaterial)
        let x = boxX
        if (this.level === 3) x = boxX + 50
        mesh.position.set(x, boxY + 110, 0)
        resolve(mesh)
      })
    })
  }
  async showText (obj = {}) {
    let {current_a = 0, current_b = 0, current_c = 0, voltage_a = 0, voltage_b = 0, voltage_c = 0, temperature = 0, energy = 0, alarmContent = []} = obj
    current_a = formatterNumber(current_a, 2)
    current_b = formatterNumber(current_b, 2)
    current_c = formatterNumber(current_c, 2)
    voltage_a = formatterNumber(voltage_a)
    voltage_b = formatterNumber(voltage_b)
    voltage_c = formatterNumber(voltage_c)
    const ctx = document.createElement('canvas').getContext('2d')
    ctx.canvas.width = this.infoPlaneWidth
    ctx.canvas.height = this.infoPlaneHeight
    const infoPlaneUrl = '/static/img/infoPlane.png'
    await this.addImage(ctx, infoPlaneUrl, [0, 0, 800, 400])
    const currentUrl = '/static/img/current.png'
    await this.addImage(ctx, currentUrl, [50, 80, 40, 40])
    const voltageUrl = '/static/img/voltage.png'
    await this.addImage(ctx, voltageUrl, [50, 265, 40, 40])
    const AxiangUrl = '/static/img/Axiang.png'
    await this.addImage(ctx, AxiangUrl, [140, 35, 30, 30])
    const BxiangUrl = '/static/img/Bxiang.png'
    await this.addImage(ctx, BxiangUrl, [140, 85, 30, 30])
    const CxiangUrl = '/static/img/Cxiang.png'
    await this.addImage(ctx, CxiangUrl, [140, 135, 30, 30])
    // 电流
    ctx.fillStyle = '#49d5f3'
    ctx.font = 'bold 30px arial'
    ctx.fillText(`${current_a}  A`, 220, 65)
    ctx.fillText(`${current_b}  A`, 220, 115)
    ctx.fillText(`${current_c}  A`, 220, 165)
    await this.addImage(ctx, AxiangUrl, [140, 220, 30, 30])
    await this.addImage(ctx, BxiangUrl, [140, 270, 30, 30])
    await this.addImage(ctx, CxiangUrl, [140, 320, 30, 30])
    ctx.font = 'bold 30px arial'
    ctx.fillText(`${voltage_a}  V`, 220, 250)
    ctx.fillText(`${voltage_b}  V`, 220, 300)
    ctx.fillText(`${voltage_c}  V`, 220, 350)
    const temperatureUrl = '/static/img/temperature.png'
    await this.addImage(ctx, temperatureUrl, [430, 40, 50, 50])
    ctx.font = 'bold 30px arial'
    ctx.fillText(`${temperature}  ℃`, 520, 80)
    const totalEnergyUrl = '/static/img/totalEnergy.png'
    await this.addImage(ctx, totalEnergyUrl, [430, 120, 50, 50])
    ctx.font = 'bold 30px arial'
    ctx.fillText(`${energy} 度`, 520, 160)
    const warningUrl = '/static/img/warning.png'
    await this.addImage(ctx, warningUrl, [430, 220, 50, 50])
    ctx.fillStyle = '#f9da02'
    ctx.font = 'bold 30px arial'
    alarmContent.forEach((alarm, index) => {
      if (index > 2) {
        const x = 520 + (index - 3) * 80
        ctx.fillText(alarm, x, 350)
      } else {
        const x = 520 + index * 80
        ctx.fillText(alarm, x, 300)
      }
    })
    ctx.fillStyle = 'rgba(255,255,255,0.5)'
    ctx.fillRect(380, 40, 2, 320)
    return ctx.canvas
  }
  // 添加背景板
  addImage (ctx, url, cord) {
    return new Promise((resolve, reject) => {
      const image = new Image()
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = url
      image.onload = function () {
        ctx.drawImage(image, ...cord)
        resolve()
      }
    })
  }
  updateInfoPlane (obj) {
    this.showText(obj).then((canvas) => {
      const texture = new THREE.CanvasTexture(canvas)
      texture.needsUpdate = true
      this.infoPlaneMaterial.map = texture
    })
  }
  // 添加电流图标
  addCurrent (parentInfo) {
    return new Promise((resolve) => {
      const group = new THREE.Group()
      const {linePath} = parentInfo
      if (!linePath) {
        const {points, distance} = this.calcPath(parentInfo)
        this.currentTexture.wrapS = THREE.RepeatWrapping
        this.currentTexture.wrapT = THREE.RepeatWrapping
        this.currentTexture.repeat.x = distance / 50
        const tube = this.createCurrent(this.currentTexture, points)
        group.add(tube)
      }
      resolve(group)
    })
  }

  // 添加电流管道
  addTube (parentInfo) {
    return new Promise((resolve) => {
      const {linePath} = parentInfo
      const group = new THREE.Group()
      if (!linePath) {
        const {points} = this.calcPath(parentInfo)
        const tube = this.createTube(points)
        group.add(tube)
      }
      resolve(group)
    })
  }
  // 没有线的坐标 - 自己计算
  calcPath ({level, x, z}) {
    const secondBoxYHalf = this.secondBox.y / 2
    const thirdBoxYHalf = this.thirdBox.y / 2 + 5
    let beginCord = []
    let beginDistance = 0
    let points = []
    let distance = []
    if (this.level === 2) {
      beginCord = [[[this.x, secondBoxYHalf, this.z], [this.x, 0, this.z]]]
      beginDistance = secondBoxYHalf
    } else if (this.level === 3) {
      beginCord = [[[this.x, thirdBoxYHalf, this.z], [this.x, 0, this.z]]]
      beginDistance = thirdBoxYHalf
    }
    if (level === 1) {
      points = [...beginCord, ...[[[this.x, tubeRadius, this.z], [this.x, tubeRadius, z]], [[this.x, tubeRadius, z], [x, tubeRadius, z]]]]
      distance = beginDistance + Math.abs(this.z - z) + Math.abs(this.x - x)
    } else if (level === 2) {
      points = [...beginCord, ...[[[this.x, tubeRadius, this.z], [this.x, tubeRadius, z]], [[this.x, tubeRadius, z], [x, tubeRadius, z]]], ...[[[x, tubeRadius, z], [x, secondBoxYHalf, z]]]]
      distance = beginDistance + Math.abs(this.z - z) + Math.abs(this.x - x) + Math.abs(secondBoxYHalf - tubeRadius)
    } else if (level === 3) {
      points = [...beginCord, ...[[[this.x, tubeRadius, this.z], [this.x, tubeRadius, z]], [[this.x, tubeRadius, z], [x, tubeRadius, z]]], ...[[[x, tubeRadius, z], [x, thirdBoxYHalf, z]]]]
      distance = [...beginDistance, ...[Math.abs(this.z - z), Math.abs(this.x - x), Math.abs(thirdBoxYHalf - tubeRadius)]]
      distance = beginDistance + Math.abs(this.z - z) + Math.abs(this.x - x) + Math.abs(thirdBoxYHalf - tubeRadius)
    }
    return {points, distance}
  }
  createTube (points) {
    const CurvePath = new THREE.CurvePath()
    const array = []
    points.forEach((res) => {
      const curve = new THREE.LineCurve3(...res.map((obj) => new THREE.Vector3(...obj)))
      array.push(curve)
    })
    CurvePath.curves.push(...array)
    const tubeGeometry = new THREE.TubeGeometry(CurvePath, 100, tubeRadius, 25, false)
    const tubeMaterial = new THREE.MeshPhongMaterial({
      color: 0xffffff,
      transparent: true,
      opacity: 0.3
    })
    const tube = new THREE.Mesh(tubeGeometry, tubeMaterial)
    return tube
  }
  createCurrent (texture, points) {
    const CurvePath = new THREE.CurvePath()
    const array = []
    points.forEach((res) => {
      const curve = new THREE.LineCurve3(...res.map((obj) => new THREE.Vector3(...obj)))
      array.push(curve)
    })
    CurvePath.curves.push(...array)
    const tubeGeometry = new THREE.TubeGeometry(CurvePath, 100, currentRadius, 50, false)
    const tubeMaterial = new THREE.MeshPhongMaterial({
      map: texture
    })
    const tube = new THREE.Mesh(tubeGeometry, tubeMaterial)
    return tube
  }
  // 处理实时数据
  update (updateObj) {
    const {isOnline, hasCurrent, infoPlaneObj} = updateObj
    // 处理上下线
    const oldOnline = this.oldRunData.isOnline
    if (oldOnline !== isOnline) {
      if (isOnline) {
        this.boxNameMesh.position.y = this.currentBox.y + 320
        this.boxMesh.material = this.onlineMaterial
        this.infoPlaneGroup.visible = true
        this.updateInfoPlane(infoPlaneObj)
      } else {
        this.boxNameMesh.position.y = this.currentBox.y + 20
        this.boxMesh.material = this.offlineMaterial
        this.infoPlaneGroup.visible = false
      }
    }
    const oldCurrent = this.oldRunData.hasCurrent
    if (!!this.parentBox && (oldCurrent !== hasCurrent)) {
      if (hasCurrent && isOnline) {
        this.currentGroup.visible = true
      } else {
        this.currentGroup.visible = false
      }
    }
    this.oldRunData = {
      isOnline,
      hasCurrent
    }
  }
  /* 添加动画 */
  progress = 0
  animate () {
    this.currentTexture.offset.x += 0.06
    if (this.progress > 1.0) {
      this.progress = 0
    }
    this.progress += 0.0009
    requestAnimationFrame(this.animate.bind(this))
  }
}



// WEBPACK FOOTER //
// ./src/common/Box.js